import React from 'react';
import LoginContainer from '../containers/Login';

const Login = () => <LoginContainer />;

export default Login;
